mutation DownloadReport($id: ID!) {
  downloadReport(id: $id) {
    url
  }
}
